import { Box, VStack, HStack, Text, Image, Center } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import Placeholder from 'assets/common/placeholder.png';
import { ReactElement } from 'react';
import { CtfImage } from '@novaheal/types';
import { ChevronRightIcon } from 'assets/icons/v2';
import { useCurrentRoute } from 'hooks/utils/useCurrentRoute';
import { ProtectedRoutes } from 'types/Routes';
import { useFirebase } from 'hooks/useFirebase';
import { NovaIcon } from 'components/ui/novaIcon';

export type ArticleSlideItemProps = {
  title: string;
  image: CtfImage;
  categoryTitle?: string | null;
  link: string;
};

const IMAGE_WIDTH = '60px';

export const ArticleSlideItem = ({
  title,
  image,
  categoryTitle,
  link,
}: ArticleSlideItemProps): ReactElement => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentRoute } = useCurrentRoute(location);
  const { logFirebaseClick } = useFirebase();
  const handleClick = (): void => {
    if (currentRoute === ProtectedRoutes.ARTICLE) {
      logFirebaseClick('article-slider', `article-${title}`);
    }
    if (currentRoute === ProtectedRoutes.HOME) {
      logFirebaseClick('article-slider', `article-${title}`);
    }
    navigate(link);
  };

  return (
    <Box
      p="15px 10px 0px"
      cursor="pointer"
      _hover={{ bg: 'background.canvas' }}
      _active={{ bg: 'background.canvas' }}
      width={{ base: '370px', md: '470px' }}
      maxW="100%"
    >
      <HStack gap="15px" onClick={handleClick} cursor="pointer" position="relative" maxW="100%">
        <Box w={IMAGE_WIDTH} h="65px" borderRadius="5px" overflow="hidden" flexShrink={0}>
          <Center height="100%">
            <Image
              src={image.url || Placeholder}
              maxHeight="100%"
              minHeight="100%"
              maxW="none"
              minWidth="100%"
              objectFit="cover"
              alt={image.description}
            />
          </Center>
        </Box>
        <VStack
          align="left"
          flexGrow="1"
          alignSelf="stretch"
          position="relative"
          overflow="hidden"
          paddingRight="30px"
          gap="5px"
        >
          <Text textStyle="body.s.regular" color="text.tertiary">
            {categoryTitle}
          </Text>
          <Text textStyle="body.m.medium" color="text.secondary" lineClamp={2}>
            {title}
          </Text>
        </VStack>
        <NovaIcon icon={ChevronRightIcon} size="l" color="text.secondary" />
      </HStack>
      <Box
        h="1px"
        w={`calc(100% - ${IMAGE_WIDTH} - 15px)`}
        borderBottom="1px solid"
        borderColor="border.accent"
        bottom="1px"
        ml="auto"
        mt="15px"
      />
    </Box>
  );
};
